import { useState, useEffect } from "react";
import { getNavContext } from "../functions/navOrder";

// Calcula el nif anterior/siguiente para una vista de detalle, recorriendo la lista
// tal y como quedó en el listado (mismos filtros y orden, guardados en sessionStorage).
//
// - entity:     clave de la entidad ("proveedores" | "comunidades").
// - currentNif: nif del elemento que se está viendo en el detalle.
// - fetchAll:   (ctx) => Promise<string[]>  devuelve TODOS los nif en orden para ese contexto.
//
// Devuelve { prev, next } con el nif vecino o null en los extremos / sin contexto.
export default function useListNavigation(entity, currentNif, fetchAll) {
  const [nav, setNav] = useState({ prev: null, next: null });

  useEffect(() => {
    let cancelado = false;
    const ctx = getNavContext(entity);
    if (!ctx || !currentNif) {
      setNav({ prev: null, next: null });
      return;
    }

    Promise.resolve(fetchAll(ctx))
      .then((nifs) => {
        if (cancelado) return;
        const lista = Array.isArray(nifs) ? nifs : [];
        const idx = lista.indexOf(currentNif);
        if (idx === -1) {
          setNav({ prev: null, next: null });
          return;
        }
        setNav({
          prev: idx > 0 ? lista[idx - 1] : null,
          next: idx < lista.length - 1 ? lista[idx + 1] : null,
        });
      })
      .catch(() => {
        if (!cancelado) setNav({ prev: null, next: null });
      });

    return () => {
      cancelado = true;
    };
    // fetchAll se omite a propósito: cambia de identidad en cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entity, currentNif]);

  return nav;
}
